import { TextField } from '@material-ui/core';
import { Autocomplete, createFilterOptions } from '@material-ui/lab';
import React, { useEffect, useState } from 'react';
import { useFormikContext } from 'formik';

const matchFromStartFilter = createFilterOptions({
  matchFrom: 'start',
});

/**
 * @param props pode-se passar outras props referentes ao Material UI Autocomplete
 * @example matchAny - altera o comportamento do autocomplete para o padrão se "true"
 * @example labelProperty - nome da propriedade usada como label dos elementos no dropdown
 * @example valueProperty - nome da propriedade capturada como valor do elemento selecionado (ex.: chaves primárias)
 * @returns {JSX.Element}
 */
export const ReportMultiAutocomplete = ({ options, label, name, labelProperty, valueProperty, onSelect, matchAny, uppercaseLabels, getOptionLabel, ...rest }) => {
  const [selectedItems, setSelectedItems] = useState([]);
  const { values } = useFormikContext();

  useEffect(() => {
    if (!values[name]) return;
    let selectedObjects = [];
    values[name].forEach(value => {
      selectedObjects.push(options.find(option => option[valueProperty] === value));
    });
    setSelectedItems(selectedObjects);
    // eslint-disable-next-line
  }, [values[name]]);

  const getOptionLabelAdapter = option => {
    let label = (getOptionLabel ? getOptionLabel(option) : option[labelProperty]);
    label = uppercaseLabels ? label?.toUpperCase() : label;

    return label;
  }

  return (
    <Autocomplete
      multiple
      limitTags={3}
      id={`autocomplete-multi-${name}`}
      filterOptions={matchAny ? undefined : matchFromStartFilter}
      name={name}
      options={options}
      getOptionLabel={getOptionLabelAdapter}
      value={selectedItems}
      onChange={(_, newValue) => {
        onSelect({ target: { name: name, value: newValue.map(v => v[valueProperty]) } });
      }}
      renderInput={params => <TextField {...params} variant="outlined" label={label} />}
      {...rest}
    />
  );
};